(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/user-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/user-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  createContext = _React.createContext,
  useState = _React.useState,
  useContext = _React.useContext,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const CHANGE_PASSWORD = svs.ticket_partner.constants.routes.CHANGE_PASSWORD;
const B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY = svs.ticket_partner.constants.localStorageKey.B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY;
const UserContext = createContext();
const useUser = () => {
  const _useState = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER_CORP)),
    _useState2 = _slicedToArray(_useState, 2),
    isLoggedIn = _useState2[0],
    setIsLoggedIn = _useState2[1];
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useLocalStorage(B2B_ONE_TIME_PASSWORD_LOCAL_STORAGE_KEY, false),
    _svs$ticket_partner$s2 = _slicedToArray(_svs$ticket_partner$s, 2),
    oneTimePassword = _svs$ticket_partner$s2[0],
    setOneTimePassword = _svs$ticket_partner$s2[1];
  const _svs$ticket_partner$s3 = svs.ticket_partner.sharedComponents.hooks.useTask(),
    status = _svs$ticket_partner$s3.status,
    result = _svs$ticket_partner$s3.result,
    error = _svs$ticket_partner$s3.error,
    run = _svs$ticket_partner$s3.run;
  const _svs$ticket_partner$s4 = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(),
    redirectToKeepReturnUrlOrBack = _svs$ticket_partner$s4.redirectToKeepReturnUrlOrBack,
    redirectToStartPage = _svs$ticket_partner$s4.redirectToStartPage;
  const companyDetailsPromise = svs.ticket_partner.sharedComponents.hooks.usePromiseDeferred();

  useEffect(async () => {
    if (isLoggedIn) {
      try {
        const _await$svs$ticket_par = await svs.ticket_partner.services.getCompanyDetails(),
          response = _await$svs$ticket_par.response;
        companyDetailsPromise.resolve({
          companyDetails: response === null || response === void 0 ? void 0 : response.companyCustomer
        });
      } catch (e) {
        companyDetailsPromise.resolve({
          companyDetails: null
        });
        svs.ticket_partner.logger.error('failed to fetch company details', e);
      }
    }
  }, [companyDetailsPromise, isLoggedIn]);
  const login = useCallback(async (email, password) => {
    try {
      await run(svs.ticket_partner.utils.login(email, password));
    } catch (e) {}
  }, [run]);
  const logout = useCallback(() => {
    svs.ui.loader.show();
    svs.core.userSession.logout();
    redirectToStartPage();
  }, []);
  useEffect(() => {
    if (status === 'resolved') {
      var _result$response, _result$response2;
      const redirect = Boolean((_result$response = result.response) === null || _result$response === void 0 || (_result$response = _result$response.userNotifications) === null || _result$response === void 0 ? void 0 : _result$response.REDIRECT);
      const loggedIn = ((_result$response2 = result.response) === null || _result$response2 === void 0 || (_result$response2 = _result$response2.session) === null || _result$response2 === void 0 ? void 0 : _result$response2.role) === svs.core.userSession.roles.RETAILER_CORP;
      setOneTimePassword(redirect);
      setIsLoggedIn(loggedIn);
      if (redirect) {
        redirectToKeepReturnUrlOrBack(CHANGE_PASSWORD);
      }
    } else if (status === 'rejected') {
      svs.ticket_partner.utils.showErrorDialog(svs.ticket_partner.utils.loginErrorMapper(error));
    }
  }, [status, result, error, setOneTimePassword]);
  return {
    isLoggedIn: isLoggedIn && !oneTimePassword,
    hasRetailerCorpRole: isLoggedIn,
    login,
    logout,
    hasOneTimePassword: oneTimePassword && isLoggedIn,
    setOneTimePasswordUpdated: () => setOneTimePassword(false),
    companyDetailsPromise: companyDetailsPromise.promise
  };
};
const UserProvider = _ref => {
  let children = _ref.children;
  const user = useUser();
  return React.createElement(UserContext.Provider, {
    value: user
  }, children);
};
function useUserContext() {
  return useContext(UserContext);
}
svs.ticket_partner.UserContext = UserContext;
svs.ticket_partner.useUserContext = useUserContext;
svs.ticket_partner.UserProvider = UserProvider;

 })(window);